























import {Component, Vue} from 'vue-property-decorator';
import {
    CaseEmailLogDetailDialogRequest, CaseEmailLogDetailRetrieveResponse, CaseEmailReceipient, CommonModelUtils, TableHeader
} from '@/model/CommonModel';
import CommonPaginatedTable from '@/components/table/CommonPaginatedTable.vue';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import CaseApi from '@/api/CaseApi';

@Component({
    components: {CommonPromptDialog, CommonPaginatedTable, CommonButton}
})
export default class CaseEmailLogDetailDialog extends Vue {
    private visible: boolean = false;
    private loading: boolean = false;
    
    private recipients: CaseEmailReceipient[] = [];
    
    get isVisible() {
        return this.visible;
    }
    
    get getRecipients() {
        return this.recipients;
    }
    
    get isLoading() {
        return this.loading;
    }
    
    get recipientsColumns(): TableHeader[] {
        return [{
            columnId: 'userName',
            columnLabel: this.$t('message.case.emailLogRecipientName').toString(),
            visible: 'Y'
        }, {
            columnId: 'address',
            columnLabel: this.$t('message.case.emailLogRecipientEmail').toString(),
            visible: 'Y'
        }];
    }
    
    public mounted() {
        this.$modal
            .getEventBus()
            .$on('emailLogDetail', (params: CaseEmailLogDetailDialogRequest) => {
                this.show(params);
            });

        this.$modal.getEventBus().$on('hideCaseEmailLogDetailDialog', () => this.onConfirm());
    }
    
    public show(request: CaseEmailLogDetailDialogRequest) {
        this.visible = true;
        this.loading = true;
        
        const emailKey = request.emailKey;
        CaseApi.retrieveCaseEmailLogDetail(emailKey)
               .then((res: CaseEmailLogDetailRetrieveResponse) => {
                   this.recipients = CommonModelUtils.getOrDefault(res.data, {recipients: []}).recipients;
               }).finally(() => this.loading = false);
    }

    public onConfirm() {
        this.visible = false;
    }

    public afterClosed() {
        this.recipients = [];
        this.loading = false;
    }

    public destroyed() {
        this.$modal.getEventBus().$off('emailLogDetail');
        this.$modal.getEventBus().$off('hideCaseEmailLogDetailDialog');
    }
}
